import { styleConstants, themeConstants } from '@paywithextend/components'
import { base_colorSurfaceMutedHover } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slower } from 'ext-ui/style/transitionSpeeds'
import { font_family_weight_medium, font_xs } from 'ext-ui/style/typography'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

export default css`
  &.UtilityToolbarFilterButton {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-end;

    &.container {
      display: inline-block;
      position: relative;

      &:hover:not(.selected) {
        .toolbar {
          background-color: ${base_colorSurfaceMutedHover};
          transition: background-color ${transition_slower} ease-out;
        }
      }

      &.selected {
        .toolbar {
          border: 1px solid ${themeConstants.colors.cta};
          background-color: ${styleConstants.colors.blue_opacity};
        }
      }
    }

    &.icon {
      max-width: ${variables.units['base-unit-4']}px;
      max-height: ${variables.units['base-unit-4']}px;
    }

    .countBadge {
      position: absolute;
      top: -8px;
      right: -8px;
      height: 16px;
      min-width: 16px;
      display: flex;
      padding: 0 ${spacing(1)};
      justify-content: center;
      align-items: center;
      border-radius: ${spacing(2)};
      background-color: ${themeConstants.colors.cta};
      ${font_xs};
      color: white;
      font-family: ${font_family_weight_medium};
      opacity: 0;
      transition: opacity ${transition_slower} ease-out;
      isolation: isolate;

      &.visible {
        opacity: 1;
      }
    }
  }
`
